// extracted by mini-css-extract-plugin
module.exports = {"newDashboardsContainer":"_2WK1g2X4"};